<template>
  <div>
    <UnbilledWorkOrderComp />
  </div>
</template>

<script>


import UnbilledWorkOrderComp from '@/views/sites/siteDashboard/components/UnbilledWorkOrders/UnbilledWorkOrderComp.vue';

export default {
    name: 'UnbilledWorkOrder',
    components: { UnbilledWorkOrderComp },
};
</script>
